import { useQueryClient } from "@tanstack/react-query";
import { useContext, useEffect, useState } from "react";
import { client } from "../../../../utils/axios-client";
import { AIOption, SingleChatResponse, ValidationError } from "../../AI-Types";
import { useGetAIContentTypes, useGetAIGoals, useGetAIRoles, useGetAITones } from "../../api/ai-options";
import { ReviewContentContext } from "../context/ReviewContentContext";

const useReviewContent = () => {
    const { chatRequest, setChatRequest, contentType } = useContext(ReviewContentContext);
    const { data: goals } = useGetAIGoals();
    const { data: tones } = useGetAITones();
    const { data: roles } = useGetAIRoles();
    const queryClient = useQueryClient();
    const { data: contentTypes } = useGetAIContentTypes();
    const [result, setResult] = useState<SingleChatResponse[]>([]);
    const [isRunning, setIsRunning] = useState(false);

    useEffect(() => {
        if (contentTypes && contentTypes.length > 0) {
            const group = contentTypes[0];
            const item = group.options.find(p => p.type === contentType);

            setChatRequest({
                ...chatRequest,
                contentType: item
            })
        }
    }, [contentType, contentTypes])

    const setGoalAndTone = (goal: AIOption, tone: AIOption) => {
        setChatRequest({ ...chatRequest, goal, tone });
    }

    const setGoal = (goal: AIOption) => {
        setChatRequest({ ...chatRequest, goal });
    }

    const setTone = (tone: AIOption) => {
        setChatRequest({ ...chatRequest, tone });
    }

    const setRole = (role: AIOption) => {
        setChatRequest({ ...chatRequest, role });
    }

    const setPrompt = (promptDetails: string) => {
        setChatRequest({ ...chatRequest, promptDetails });
    }

    const getResponse = async () => {
        setIsRunning(true);

        const res = await queryClient.fetchQuery<any>({
            queryKey: ['review-text'],
            queryFn: () => {
                return client.post<SingleChatResponse[]>(`/api/ai/chat/review`,
                    {
                        text: chatRequest.promptDetails,
                        roleId: chatRequest.role!.id,
                        contentTypeId: chatRequest.contentType!.id,
                        goalId: chatRequest.goal ? chatRequest.goal.id : undefined,
                        toneId: chatRequest.tone ? chatRequest.tone.id : undefined
                    }).then((res) => res.data)
            },
        });

        setResult(res)
        setIsRunning(false);
    }

    return {
        chatRequest,
        setGoal,
        setTone,
        setGoalAndTone,
        setRole,
        setPrompt,
        getResponse,
        isRunning,
        result,
        goals: goals ?? [],
        tones: tones ?? [],
        roles: roles ?? []
    }
}

export default useReviewContent;